// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Text } from '@mantine/core';
import { FC } from 'react';
import { i18n } from '@lingui/core';
import { useNavigate, useParams } from 'react-router-dom';
import { CreateDocumentConfigDTO, ProcedureReportProps } from '../../../../Types/LogT';
import LinkText from '../../../../Atoms/LinkText';

const CreateDocumentReport: FC<ProcedureReportProps> = ({ report, config }) => {
  const { entityId, executionStatus } = report ?? {};
  const { documentType, templateName, originDocument } = config as CreateDocumentConfigDTO;
  const navigate = useNavigate();
  const { id: eventId } = useParams();
  const documentCreated = executionStatus === 'COMPLETED';

  const onClick = () => {
    if (eventId && documentCreated) {
      navigate(`/events/${eventId}/documents/${entityId}`);
    }
  };

  const documentNode = () => (
    <Text
      span
      weight="bolder"
      onClick={onClick}
      variant={documentCreated ? 'link' : 'text'}
      sx={(theme) => ({
        cursor: documentCreated ? 'pointer' : 'default',
        color: documentCreated
          ? theme.colorScheme === 'dark'
            ? theme.colors.blue[1]
            : theme.colors.blue[4]
          : 'inherit',
      })}
    >
      {i18n._(`document.${documentType.toLowerCase()}`)}
    </Text>
  );

  if (originDocument) {
    const { label } = originDocument;
    return (
      <Text>
        {documentNode()}
        {'  '}wurde aus Dokument{'  '}
        <Text span weight="bolder">
          {label}
        </Text>
        .
      </Text>
    );
  }

  if (templateName) {
    return (
      <Text>
        {documentNode()}
        {'  '}wurde aus Vorlage{'  '}
        <LinkText
          span
          weight="bolder"
          onClick={() => navigate(`/settings/template/document/${documentType.toLowerCase()}/${templateName}`)}
        >
          {templateName}
        </LinkText>
        {'  '}erstellt.
      </Text>
    );
  }

  return null;
};

export default CreateDocumentReport;
